import { generateUtilityClass, generateUtilityClasses } from '../styles/classes';
export var selectableCardComponentName = 'QuantumSelectableCard';
export function getSelectableCardUtilityClass(slot) {
    return generateUtilityClass(selectableCardComponentName, slot);
}
export var selectableCardClasses = generateUtilityClasses(selectableCardComponentName, [
    'root',
    'controlRadio',
    'controlCheckbox',
    'content',
    'label',
    'helperText',
]);
